import React, { useEffect, useState, useCallback } from 'react';
import ModuleHeading from '../../component/ModuleHeading';
import { Card, CardContent, IconButton, Divider, Typography, TextField } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { StyledButton } from '../../component/StyledComponent';
import { get, patch, post } from '../../services/api-services';
import { useCommon } from '../../context/CommonContext';

export default function Settings() {
    const [isEditMode, setIsEditMode] = useState(false);
    const [tax, setTax] = useState({ taxType: "GST", taxValue: 0 });
    const [error, setError] = useState(false);
    const [helperText, setHelperText] = useState('');
    const [updatedTax, setUpdatedTax] = useState({});
    const { setSnackbar } = useCommon();

    const handleEditToggle = () => {
        setIsEditMode(!isEditMode);
        setError(false);
        setHelperText('');
    };

    const handleChange = (e) => {
        const inputValue = e.target.value;
        
        if (inputValue === '') {
            setTax({ ...tax, taxValue: '' });
            setError(true);
            setHelperText('Tax is required');
        } else {
            const numericValue = Number(inputValue);
            if (isNaN(numericValue)) {
                setError(true); 
                setHelperText('Must be a valid number');
            } else if (numericValue < 0) {
                setError(true);
                setHelperText('Tax cannot be negative');
            } else if (numericValue > 100) {
                setError(true);
                setHelperText('Tax cannot exceed 100%');
            } else {
                setError(false); 
                setHelperText('');
                setTax({ ...tax, taxValue: numericValue });  
            }
        }
    };

    const onSubmit = async () => {
        const taxToSave = tax.taxValue === '' ? 0 : tax.taxValue;
        const payload = { ...tax, taxValue: taxToSave };
        
        let res;
        if (updatedTax?.id) {
            res = await patch(`/Settings/${updatedTax.id}`, payload);
        } else {
            res = await post('/Settings', payload);
        }

        if (res?.statusCode === 200) {
            setSnackbar({
                openSnackbar: true,
                message: 'GST updated successfully!',
                severity: 'success'
            });
            setIsEditMode(!isEditMode);
            onGetSettings();
        }
    };

    const onGetSettings = useCallback(async () => {
        const res = await get(`/Settings`);
        if (res?.statusCode === 200) {
            if (res?.data && res.data.length > 0) {
                setUpdatedTax(res.data[0]);
                setTax((prevTax) => ({ ...prevTax, taxValue: res.data[0]?.taxValue }));
            } else {
                setUpdatedTax({});
                setTax((prevTax) => ({ ...prevTax, taxValue: 0 }));
            }
        }
    }, []);

    useEffect(() => {
        onGetSettings();
    }, [onGetSettings]);

    return (
        <div>
            <ModuleHeading title="Settings" navigateTo="/admin/dashboard" />
            <Card sx={{ mb: 2 }}>
                <CardContent>
                    <div className='flex justify-between items-center mb-4'>
                        <Typography sx={{ fontSize: 18, fontWeight: 500 }}>
                            GST
                        </Typography>
                        <Typography>
                            {updatedTax?.taxValue}%
                        </Typography>
                        <IconButton
                            onClick={handleEditToggle}
                        >
                            <Edit color="primary" />
                        </IconButton>
                    </div>
                    {isEditMode && <div className='flex space-x-2 md:w-1/2 items-center'>
                        <TextField
                            id="standard-basic"
                            label="Tax"
                            type='number'
                            variant="standard"
                            value={tax.taxValue === '' ? '' : tax.taxValue}  
                            error={error}
                            helperText={helperText}
                            required
                            fullWidth
                            onFocus={() => {
                                if (tax.taxValue === 0) {
                                    setTax({ ...tax, taxValue: '' });  
                                }
                            }}
                            onChange={handleChange}
                            onBlur={() => {
                                if (tax.taxValue === '') {
                                    setError(true); 
                                    setHelperText('Tax is required');
                                } else {
                                    setError(false);  
                                    setHelperText('');
                                }
                            }}
                        />

                        <StyledButton 
                            className='h-[36px]' 
                            disabled={tax.taxValue === '' || error}
                            onClick={onSubmit}
                        >
                            Save
                        </StyledButton>
                    </div>}
                </CardContent>
                <Divider />
            </Card>
        </div>
    );
}
